import Icon from "../Icon/Icon";
import style from "./Loader.module.scss";
import LoaderLogo from "../../icons/loader.svg";

export const Loader = () => {
  return (
    <div className={style.overlay}>
      <Icon name={LoaderLogo} />
    </div>
  );
};
